import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Japanese%20minimalist%20aesthetic%20warm%20atmosphere%20with%20soft%20natural%20light%2C%20traditional%20Japanese%20architectural%20elements%20blended%20with%20modern%20design%2C%20warm%20cream%20and%20terracotta%20tones%2C%20subtle%20texture%2C%20elegant%20composition%2C%20wide%20banner%20format&width=1800&height=900&seq=hero-japan-main-01&orientation=landscape"
        alt="亚洲一级日本精选内容导航"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 md:mb-6 leading-tight">
          亚洲一级日本精选内容导航
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mb-6 md:mb-8 leading-relaxed">
          汇聚日本文化、影视、美食、旅游等一级类目优质资源，为您提供权威全面的日本内容指南
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/japan-travel"
            className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-md text-sm font-medium whitespace-nowrap transition-all duration-200"
          >
            探索内容分类
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 bg-white/15 hover:bg-white/25 text-white backdrop-blur-sm rounded-md text-sm font-medium whitespace-nowrap transition-all duration-200"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}